module.exports = __webpack_public_path__ + "static/media/3.91c25369.jpg";